import { render, staticRenderFns } from "./DetailTabs.vue?vue&type=template&id=98d6d9ee"
import script from "./DetailTabs.vue?vue&type=script&lang=js"
export * from "./DetailTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports